(() => {
  if (window.beautyContactFormReady) return;
  window.beautyContactFormReady = true;

  document.addEventListener(
    'submit',
    async (event) => {
      const form = event.target.closest('form.js-beauty-contact-form');
      if (!form) return;

      const button = form.querySelector('[type="submit"]');
      if (button) {
        button.disabled = true;
        button.classList.add('is-loading');
        button.setAttribute('aria-busy', 'true');
      }

      const isLocalPreview = ['127.0.0.1', 'localhost'].includes(window.location.hostname);
      if (!isLocalPreview) return;

      event.preventDefault();
      if (!form.reportValidity()) return;

      const message = form.querySelector('[data-contact-message]');
      if (!message) return;

      form.reset();
      message.textContent =
        'Preview mode: your form is working. Shopify sends contact messages only from the online store preview or published store.';
      message.classList.remove('is-error');
      message.classList.add('is-visible');
      message.focus({ preventScroll: true });

      if (button) {
        button.disabled = false;
        button.classList.remove('is-loading');
        button.removeAttribute('aria-busy');
      }
    },
    true
  );
})();
